const Label = ({
  htmlFor,
  children,
  isRequired,
  className,
  setValue,
  ...props
}) => {
  if (setValue) {
    return (
      <label
        htmlFor={htmlFor}
        className={`block text-sm text-gray-500 pb-1 pl-2 ${className}`}
        {...props}
      >
        {setValue}
        {isRequired && <span className="text-red-500">*</span>}
      </label>
    );
  } else {
    return (
      <label
        htmlFor={htmlFor}
        className={`block text-sm text-[#4C4C66] pb-1 pl-2 ${className}`}
        {...props}
      >
        {children}
        {isRequired && <span className="text-red-500">*</span>}
      </label>
    );
  }
};

export default Label;